<template>
  <div>
    <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>

    <ots-refer
      class="mb20"
      :selectList="selectList"
      :request-form="stuSelectParams"
      @search="getStudentList"
    />
    <p style="margin-left: 20px;">
      <span v-if="tableData.length > 0">考试批次：{{ tableData[0].planName }} </span>
      <span style="color: red; margin-left: 20px;" v-if="tableData.length > 0">说明：分数为学生原始作答分数，成绩为发布后学生平台的查询结果</span>
      <span style="color: red;" v-else>说明：分数为学生原始作答分数，成绩为发布后学生平台的查询结果</span>
    </p>
    <div class="mainCon">
      <ots-table-group
        :tableHeader="tableHeader"
        :tableData="tableData"
        :pagination="pagination"
        @changeNum="changeSize"
        @changePage="changePage"
      ></ots-table-group>
    </div>

    <!-- <ots-custom-dialog :dialog.sync="lookImgAll" title="查看违纪照片">
      <template v-slot:content>
        <div class="dialogImg">
          <div
            v-for="item in disciplineImg"
            :key="item.index"
            class="disciplineImg"
          >
            <img :src="item" alt="" />
          </div>
        </div>
      </template>

      <template v-slot:footer>
        <el-button round @click="lookImgAll = false">关闭</el-button>
      </template>
    </ots-custom-dialog> -->

    <ots-custom-dialog :dialog.sync="lookImgAll" title="查看异常状态">
      <template v-slot:content>
        <div>
          <el-form inline label-width="100px">
            <div>
              <el-form-item label="学生姓名">
                <span>{{ nowRealName }}</span>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="证件号码">
                <span>{{ nowCardNo }}</span>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="考试状态">
                {{ nowCheckStateName }}
              </el-form-item>
            </div>
            <div>
              <el-form-item label="考生详情">
                <span><el-link type="primary" @click="lookDetail()">查看考生详情</el-link></span>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="巡考违纪照片">
                <div class="showImgClass" v-if="imageList1 && imageList1.length > 0">
                  <div
                    v-for="item in imageList1"
                    :key="item.index"
                    class="showImgClassInner"
                  >
                    <img :src="item" alt=""/>
                  </div>
                </div>
                <div class="showImgClass" v-else>无</div>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="考中违纪照片">
                <div class="showImgClass" v-if="imageList2 && imageList2.length > 0">
                  <div
                    v-for="item in imageList2"
                    :key="item.index"
                    class="showImgClassInner"
                  >
                    <img :src="item" alt="" />
                  </div>
                </div>
                <div class="showImgClass" v-else>无</div>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="补充违纪材料">
                <div class="showImgClass" v-if="imageList3 && imageList3.length > 0">
                  <div
                    v-for="item in imageList3"
                    :key="item.index"
                    class="showImgClassInner"
                  >
                    <img :src="item" alt="" />
                  </div>
                </div>
                <div class="showImgClass" v-else>无</div>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="补充描述">
                {{ nowCheckStateRemark ? nowCheckStateRemark : "无"}}
              </el-form-item>
            </div>
          </el-form>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="lookImgAll = false">关闭</el-button>
      </template>
    </ots-custom-dialog>

    <ots-custom-dialog :dialog.sync="gradeDialog" title="考生单科成绩" width="480px">
      <template v-slot:content>
        <div class="score_dialog">
          <p class="info"><span>姓名：</span>{{gradeForm.realName}}</p>
          <p class="info"><span>证件号：</span>{{gradeForm.cardNo}}</p>
          <p class="info"><span>准考证号：</span>{{gradeForm.entranceCode}}</p>
          <p class="line"></p>
          <p class="score title"><span>{{gradeForm.courseName}}：</span><span>{{gradeForm.score}}</span></p>
          <p class="score" v-for="item in gradeForm.data" :key="item.subCourseId"><span>{{item.subCourseName}}：</span><span>{{item.score}}</span></p>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="gradeDialog = false">关闭</el-button>
      </template>
    </ots-custom-dialog>

    <!-- 单个处理异常弹窗--查看 -->
    <ots-custom-dialog :dialog.sync="signShowDialog" title="查看异常状态" width="50%">
      <template v-slot:content>
        <div>
          <el-form inline label-width="100px">
            <div>
              <el-form-item label="学生姓名">
                <span>{{ currentStudent.realName }}</span>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="证件号码">
                <span>{{ currentStudent.cardNo }}</span>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="考试状态">
                {{ nowCheckStateName }}
              </el-form-item>
            </div>
            <div>
              <el-form-item label="考生详情">
                <div class="BubbleTrigger">
                  <el-link type="primary" @click="lookDetailRight()">查看考生详情</el-link>
                  <div class="bubbleSelf" v-if="showBubble">
                    <button class="close-btn" @click.stop="closeBubble">×</button>
                    <div>
                      <div class="radio" style="margin-left:15px;">
                        排序：
                        <el-radio-group v-model="reverse" style="padding-top: 10px; box-sizing: border-box">
                          <el-radio :label="false">正序</el-radio>
                          <el-radio :label="true">倒序</el-radio>
                        </el-radio-group>
                      </div>

                      <el-timeline :reverse="reverse" class="timeline" style="margin:20px 0 0 20px;">
                        <el-timeline-item
                          v-for="(activity, index) in activities"
                          :key="index"
                          color="#006aff"
                          :timestamp="activity.nodeTime"
                        >
                          {{activity.nodeName}}
                        </el-timeline-item>
                      </el-timeline>
                    </div>
                  </div>
                </div>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="巡考违纪照片">
                <div class="showImgClass" v-if="imageList1 && imageList1.length > 0">
                  <div
                    v-for="item in imageList1"
                    :key="item.index"
                    class="showImgClassInner"
                    @click = "bigImg(item)"
                  >
                    <img :src="item" alt=""/>
                  </div>
                </div>
                <div class="showImgClass" v-else>无</div>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="考中违纪照片">
                <div class="showImgClass" v-if="imageList2 && imageList2.length > 0">
                  <div
                    v-for="item in imageList2"
                    :key="item.index"
                    class="showImgClassInner"
                    @click = "bigImg(item)"
                  >
                    <img :src="item" alt="" />
                  </div>
                </div>
                <div class="showImgClass" v-else>无</div>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="补充违纪材料">
                <div class="showImgClass" v-if="imageList3 && imageList3.length > 0">
                  <div
                    v-for="item in imageList3"
                    :key="item.index"
                    class="showImgClassInner"
                    @click = "bigImg(item)"
                  >
                    <img :src="item" alt="" />
                  </div>
                </div>
                <div class="showImgClass" v-else>无</div>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="补充描述">
                {{ nowCheckStateRemark ? nowCheckStateRemark : "无"}}
              </el-form-item>
            </div>
          </el-form>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="signShowDialog = false">关闭</el-button>
      </template>
    </ots-custom-dialog>

    <el-drawer title="查看考生详情" :visible.sync="lookFlag" direction="ltr" >
      <div style="margin-left: 50px;">
        <div class="radio" style="margin-bottom: 20px;">
          排序：
          <el-radio-group v-model="reverse" style="padding-top: 10px; box-sizing: border-box">
            <el-radio :label="false">正序</el-radio>
            <el-radio :label="true">倒序</el-radio>
          </el-radio-group>
        </div>

        <el-timeline :reverse="reverse" class="timeline" style="margin-left: 50px;">
          <el-timeline-item
            v-for="(activity, index) in activities"
            :key="index"
            color="#006aff"
            :timestamp="activity.nodeTime"
          >
            {{activity.nodeName}}
          </el-timeline-item>
        </el-timeline>
      </div>
    </el-drawer>

  </div>
</template>
<script>
import {
  getPlanCourseFn,
  batchPrintCertificateFn,
} from "@/http/modules/baseSet/course";

import {
  getStudentScoreListFn,
  getOtsUrlFn,
  exportStudentScoreFn,
  getExamCheckStateFn,
  getStudentSubCourseListAPI,
  exportSubCourseScoreAPI,
  queryExamCheckStateFn,
} from "@/http/modules/examSet/score";
import {
  getSelectPlanFn,
  catePrint,
  ConfigData,
} from "@/http/modules/examSet/examBatch";
import { getPlaceInfofn } from "@/http/modules/baseSet/majorCourse";
import { sync } from "glob";
import { queryDetailListAPI } from "@/http/modules/computedRoomExam";

const photoState = {
  0: "未通过",
  1: "通过",
  2: "-",
};
export default {
  name: "",
  data() {
    return {
      lookFlag: false,
      reverse: false,
      activities: [],
      nowRealName: "",
      nowCardNo: "",
      nowCheckStateName: "",
      imageList1: [],
      imageList2: [],
      imageList3: [],
      nowCheckStateRemark: "",
      //disciplineImg: [],
      lookImgAll: false,
      importDialog: false,
      setValuePrint: 0,
      mainTopBtnList: [
        {
          title: "导出",
          fn: this.exportScore,
        },
        {
          title: "导出单科成绩",
          fn: this.export,
        },
        {
          title: "批量下载合格证",
          fn: this.lonwall,
        },
      ],
      selectList: [
        {
          title: "考试批次",
          type: "select",
          requestKey: "planId",
          label: "name",
          isSearch: true,
          value: "id",
          data: [],
        },
        {
          title: "教学点",
          type: "select",
          isSearch: true,
          requestKey: "stationId",
          label: "name",
          value: "id",
          data: [{ id: "", name: "全部" }],
        },
        {
          title: "考点",
          type: "select",
          isSearch: true,
          requestKey: "placeId",
          label: "placeName",
          value: "placeId",
          data: [],
        },
        {
          title: "系统验证",
          type: "select",
          requestKey: "systemAuditStatus",
          label: "name",
          value: "id",
          data: [
            {
              name: "全部",
              id: "",
            },
            {
              name: "通过",
              id: 1,
            },
            {
              name: "未通过",
              id: 0,
            },
          ],
        },
        {
          title: "人工审核",
          type: "select",
          multiple: true,
          requestKey: "humanAuditState",
          label: "name",
          value: "id",
          data: [
            {
              name: "未审核",
              id: 0,
            },
            {
              name: "审核不通过",
              id: 1,
            },
            {
              name: "审核通过",
              id: 2,
            },
          ],
        },
        {
          title: "考试状态",
          type: "select",
          multiple: true,
          requestKey: "checkState",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "课程",
          type: "select",
          multiple: true,
          requestKey: "courseId",
          label: "courseName",
          value: "courseId",
          data: [],
        },
        {
          title: "关键词",
          type: "input",
          placeholder: "姓名/准考证号/证件号",
          requestKey: "searchKey",
        },
        {
          title: "强制交卷",
          type: "select",
          requestKey: "forceSubmit",
          label: "name",
          value: "id",
          data: [
            { id: "", name: "全部" },
            { id: "1", name: "是" },
            { id: "0", name: "否" }
          ]
        },
        {
          title: "分数段",
          type: "inputInterval",
          placeholder: "例如0-59",
          requestKey: "minScore",
          requestKeySecond: "maxScore",
        },
        {
          title: "是否合格",
          type: "select",
          requestKey: "isPass",
          label: "name",
          value: "id",
          data: [
            { id: "", name: "全部" },
            { id: "1", name: "是" },
            { id: "0", name: "否" }
          ]
        },
      ],
      stuSelectParams: {
        planId: "",
        courseId: [],
        searchKey: "",
        stationId: [""],
        systemAuditStatus: "",
        humanAuditState: [],
        checkState: [],
        scorePublish: 1,
        placeId: [],
        forceSubmit: "",
        minScore: "",
        maxScore: "",
        isPass: "",
      },
      tempSelecForm: [
        {
          stationId: [""],
        },
      ],
      stuListParams: {
        page: 1,
        size: 10,
      },
      tableHeader: [
        // {
        //   title: "考试批次",
        //   prop: "planName",
        // },
        {
          title: "姓名",
          prop: "realName",
        },
        {
          title: "准考证号",
          type : "textTooltip",
          prop: "entranceCode",
          width: "120",
          data: function(scope) {
            let obj = "";
            obj += `<div style="line-height:25px; padding:1px 5px 1px 5px;">教学点：${scope.row.stationName}</div>`;
            obj += `<div style="line-height:25px; padding:1px 5px 1px 5px;">考点：${scope.row.placeName}</div>`;
            obj += `<div style="line-height:25px; padding:1px 5px 1px 5px;">教室：${scope.row.className}</div>`;
            obj += `<div style="line-height:25px; padding:1px 5px 1px 5px;">座位号：${scope.row.seatNo}</div>`;
            return obj;
          },
        },
        {
          title: "证件号",
          width: "150",
          prop: "cardNo",
        },
        {
          title: "考试课程",
          prop: "courseName",
        },
        // {
        //   title: "教学点",
        //   prop: "stationName",
        // },

        // {
        //   title: "考点",
        //   prop: "placeName",
        // },
        {
          title: "成绩",
          prop: "publishResult",
        },
        {
          title: "分数",
          prop: "score",
        },
        {
          title: "客观题分数",
          prop: "objectiveScore",
        },
        {
          title: "主观题分数",
          prop: "subjectiveScore",
        },
        {
          title: "单科成绩",
          type: "button",
          width: "120",
          prop: "singleGrades",
          formatter: (val) => { return "查看" },
          disableFn: (val) => val.row.checkState == "正常" &&  val.row.courseFlag == 1 ? false : true,
          click: this.goSingleGrades,
        },
        {
          title: "作答详情",
          type: "button",
          formatter: (val) => (val.row.recordId == "scoreimport" ? "" : "查看"),
          disableFn: (val) =>
            val.row.publishResult == "" || val.row.checkState == "缺考"
              ? true
              : false,
          click: this.goOTS,
        },
        {
          title: "系统验证",
          prop: "photoCheckState",
          formatter: (val) => photoState[val.row.photoCheckState] || "数据错误",
        },
        {
          title: "人工审核",
          prop: "humanAuditState",
        },
        {
          title: "考试状态",
          prop: "checkState",
        },
        // {
        //   title: "违纪照片",
        //   type: "button",
        //   prop: "photo",
        //   formatter: (val) =>
        //   (val.row.stateUrl  === null || val.row.stateUrl.length == 0) ? '':'查看' ,
        //   click: this.loolImg,
        //   disableFn: (val) => ( (val.row.stateUrl  === null || val.row.stateUrl.length == 0) ? true : false),
        // },
        {
          title: "违纪记录",
          type: "button",
          formatter: (val) => (val.row.stateUrl  === null || val.row.stateUrl.length == 0) ? '查看':'查看' ,
          click: this.seeCheckState,
          disableFn: (val) => (val.row.checkState !== "" && val.row.checkState !== "缺考" && val.row.checkState !== "正常" ? false : true),
        },
        {
          title: "是否合格",
          prop: "isPassName"
        },
        {
          title: "合格证下载",
          width: 200,
          type : "button",
          prop: "certificateCode",
          formatter: (val) => val.row.isPass === 1 ? val.row.certificateCode : "",
          disableFn: (val) => val.row.isPass === 1 && this.setValuePrint === 1 ? false : true,
          click: this.downloadFiles,
        },
      ],
      tableData: [],
      pagination: {
        total: 0,
      },
      roleType: "",
      // 单科成绩
      singleGradesDialog: false,
      gradeDialog: false,
      gradeForm: {
        realName: '',
        entranceCode: '',
        score: '',
        cardNo: '',
        courseName: '',
        data: [],
      },
      signShowDialog: false,
      currentStudent: {},
      showBubble: false,
    };
  },
  watch: {
    "stuSelectParams.planId": function (val) {
      //清空教学点和考点
      if (this.roleType === 3) {
        this.stuSelectParams.placeId = [];
        this.$set(this.selectList[2], "data", []);
        /* *** 批次变化, 重置课程 *** */
        this.initCourseList(val);
        /* *** 批次变化,重新搜索 *** */
        this.getStudentList();
        this.getPlaceListFn();
      } else {
        this.stuSelectParams.stationId = [];
        this.stuSelectParams.placeId = [];
        this.$set(this.selectList[2], "data", []);
        /* *** 批次变化, 重置课程 *** */
        this.initCourseList(val);
        /* *** 批次变化,重新搜索 *** */
        this.getStudentList();
      }
    },
    "stuSelectParams.stationId": function () {
      this.stuSelectParams.placeId = [];
      this.getPlaceListFn();
    },
  },
  created() {
    this.initData();
    this.getExamStatus();
    this.ConfigDataitemts();
  },
  methods: {

    async export() {
      const { data, code } = await exportSubCourseScoreAPI({planId: this.stuSelectParams.planId});
      if (code) {
        window.open(data);
      }
    },


    async goSingleGrades(row) {
      let { planId } = this.stuSelectParams;
      let params = {
        planId,
        courseId: row.courseId,
        stuId: row.userId,
      }
      const { data } = await getStudentSubCourseListAPI(params);
      this.gradeForm.score = row.score;
      this.gradeForm.realName = row.realName;
      this.gradeForm.entranceCode = row.entranceCode;
      this.gradeForm.cardNo = row.cardNo;
      this.gradeForm.courseName = row.courseName;
      this.gradeForm.data = data;
      this.gradeDialog = true;
    },

    //获取考试状态下拉数据
    getExamStatus() {
      getExamCheckStateFn().then((res) => {
        if (res.code === 1) {
          this.$set(this.selectList[5], "data", res.data);
        }
      });
    },
    /**************************
     * @initData 初始化表单数据
     *************************/
    async initData() {
      /* *** 考试批次列表 *** */
      let { data } = await getSelectPlanFn({ needAudit: 7 });
      // let planList = [{ id: "", name: "全部" }, ...data];
      this.$set(this.selectList[0], "data", data);
      this.stuSelectParams.planId = data[0].id;

      /* *** 教学点列表 *** */
      this.mixin_getCommonInfo().then((res) => {
        this.roleType = res.roleType;
        if (res.roleType == 3) {
          this.unStation = false;
          this.mixin_getSelectStation().then((data) => {
            let stationId = data.filter((item) => item.id === res.stationId);
            this.$set(this.selectList[1], "data", stationId);
            this.stuSelectParams.stationId = stationId[0].id;
          });
        } else {
          this.mixin_getSelectStation().then((data) => {
            // let newStationList = [{ id: "", name: "全部" }, ...data];
            this.$set(this.selectList[1], "data", data);
          });
        }
      });
    },
    async ConfigDataitemts() {
      let { data } = await ConfigData();
      data.configList.map((e) => {
        if (e.setName == 'needCertificatePrint' && e.setValue == 1) {
          this.setValuePrint = 1;
        }
      });
    },
    async loolImg(val) {
      this.lookImgAll = true;
      // this.disciplineImg = val.stateUrl;
      this.nowRealName = val.realName
      this.nowCardNo = val.cardNo
      const { code, data } = await queryExamCheckStateFn({studentCourseId:val.studentCourseId})
      if(code == 1){
        this.nowCheckStateName = data.data.checkStateName;
        this.nowCheckStateRemark = data.data.checkStateRemark;
        this.imageList1 = data.data.url001;
        this.imageList2 = data.data.url002;
        this.imageList3 = data.data.url003;
      }
    },
    batchSetSignimg() {
      this.lookImgAll = false;
    },
    // getCurrentPlan() {
    //    /* *** 当前考试批次 *** */
    //    this.mixin_getCurrentPlanInfo().then((data) => {
    //     this.stuSelectParams.planId = data.id;
    //   });
    // },
    //考点列表

    getPlaceListFn() {
      if (this.stuSelectParams.stationId.length) {
        getPlaceInfofn({
          planId: this.stuSelectParams.planId,
          stationIds: this.stuSelectParams.stationId.toString(),
        }).then((res) => {
          this.$set(this.selectList[2], "data", res.data);
        });
      }
    },

    /*********************************
     * @initCourseList 课程随着批次变化
     ********************************/
    async initCourseList(val) {
      /* *** 根据批次获取课程 *** */
      this.stuSelectParams.courseId = [];
      const { data: courseData } = await getPlanCourseFn({ planId: val });
      this.selectList[6].data = courseData;
    },

    
    /*********************************
     * @param { 批量下载合格证 }
     ********************************/
    lonwall() {
      let params;
      if (!/^\d*$/.test(this.stuSelectParams.minScore)) {
        this.stuSelectParams.minScore = "";
      }
      if (!/^\d*$/.test(this.stuSelectParams.maxScore)) {
        this.stuSelectParams.maxScore = "";
      }
      params = Object.assign(this.stuSelectParams);
      params.checkState = params.checkState.toString();
      params.courseId = params.courseId.toString();
      params.placeId = params.placeId.toString();
      params.humanAuditState = params.humanAuditState.toString();
      delete params.scorePublish;
      batchPrintCertificateFn(params).then((res) => {
        if (res.code == 1) {
          this.$message.success(res.data);
          // window.open(res.data);
        }
      });
    },
    changeSize(num) {
      this.stuListParams.size = num;
      this.getStudentList();
    },
    changePage(p) {
      this.stuListParams.page = p;
      this.getStudentList(true);
    },
    async getStudentList(page) {
      let params;
      if (!/^\d*$/.test(this.stuSelectParams.minScore)) {
        this.stuSelectParams.minScore = "";
      }
      if (!/^\d*$/.test(this.stuSelectParams.maxScore)) {
        this.stuSelectParams.maxScore = "";
      }
      if (!page) {
        this.stuListParams.page = 1;
        params = Object.assign(this.stuListParams, this.stuSelectParams);
      } else {
        params = Object.assign(this.stuTempParams, {
          page: this.stuListParams.page,
        });
      }
      if (typeof params.stationId == "object") {
        params.stationId = params.stationId.join(",");
      }
      params.humanAuditState = params.humanAuditState.toString();
      params.checkState = params.checkState.toString();
      params.courseId = params.courseId.toString();
      params.placeId = params.placeId.toString();
      const { data } = await getStudentScoreListFn(params);
      this.stuTempParams = params;
      let tmpData = [...data.records];
      tmpData = tmpData.map(item => {
        return {
          ...item,
          isPassName : item.isPass == 1 ? '合格' : '不合格'
        }
      })
      this.tableData = tmpData;
      this.pagination.total = data.total;
    },
    async goOTS(row) {
      let params = {
        action: "getTReviewDetails",
        parames: `argumentsId=${row.recordId}&curPage=JudgeLib`,
      };
      const { code, data } = await getOtsUrlFn(params);
      if (code == 1) {
        window.open(data);
      }
    },
    async downloadFiles(row) {
      let param = {
        planId: row.planId,
        cardNo: row.cardNo,
        courseId: row.courseId,
      };
      const { data } = await catePrint(param);
      if (data) {
        window.open(data);
      }
    },
    exportScore() {
      if (!/^\d*$/.test(this.stuSelectParams.minScore)) {
        this.stuSelectParams.minScore = "";
      }
      if (!/^\d*$/.test(this.stuSelectParams.maxScore)) {
        this.stuSelectParams.maxScore = "";
      }
      let params = { ...this.stuSelectParams };
      // params.stationId = params.stationId.join();
      params.stationId = Array.isArray(params.stationId) ? params.stationId.join() : (params.stationId || '');

      exportStudentScoreFn(params).then((res) => {
        if (res.code == 1) {
          window.open(res.data);
        }
      });
    },
    seeCheckState(val){
      this.showBubble = false;
      this.currentStudent = val;
      this.signShowDialog = true;
      this.getPhotoList();
    },
    async getPhotoList(){
      const { code, data } = await queryExamCheckStateFn({studentCourseId:this.currentStudent.studentCourseId});
      if(code == 1){
        this.nowCheckStateName = data.data.checkStateName;
        this.nowCheckStateRemark = data.data.checkStateRemark;
        this.imageList1 = data.data.url001;
        this.imageList2 = data.data.url002;
        this.imageList3 = data.data.url003;
      }
    },
    async lookDetail(){
      this.lookFlag = true;
      let params = {
        planId: this.currentStudent.planId,
        courseId: this.currentStudent.courseId,
        userId: this.currentStudent.userId,
      }
      const {code,data: activities} = await queryDetailListAPI(params)
      if (code == 1) {
        this.activities = activities;
      }
    },
    bigImg(item){
      window.open(item);
    },
    async lookDetailRight(){
      let params = {
        planId: this.currentStudent.planId,
        courseId: this.currentStudent.courseId,
        userId: this.currentStudent.userId,
      }
      const {code,data: activities} = await queryDetailListAPI(params)
      if (code == 1) {
        this.activities = activities;
      }
      this.showBubble = true;
    },
    closeBubble() {
      this.showBubble = false;
    },
  },
};
</script>
<style lang="less" scoped>
.btnall {
  background: #006aff;
  color: #fff;
  margin-bottom: 16px;
  border-radius: 20px;
}

.disciplineImg {
  padding: 20px;
  img {
    width: 115px;
    height: 162px;
  }
}
.dialogImg {
  display: flex;
  flex-flow: row wrap;
  margin-left: 8%;
}
.score_dialog {
  p {
    font-size: 16px;
    line-height: 36px;
  }

  .line {
    border-top: 1px dashed #ccc;
    margin: 16px 0;
  }
  .info {
    display: inline-block;
    margin-right: 16px;
    span {
      display: inline-block;
      text-align: right;
      font-weight: 700;
    }
  }
  .score {
    span:first-child {
      display: inline-block;
      width: 208px;
      text-align: right;
    }
  }
  .score.title {
    font-weight: 700;
  }
}
.showImgClassInner {
  padding: 12px;
  img {
    width: 115px;
    height: 162px;
  }
}
.showImgClass {
  display: flex;
  flex-flow: row wrap;
  margin-left:20% ;
}
.BubbleTrigger {
  position: relative;
}

.bubbleSelf {
  position: absolute;
  top: -25px;
  left: 100%;
  margin-left: 15px;
  background: white;
  border-radius: 10px;
  padding: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  width: 300px;
  border: 1px solid #ddd;
  z-index: 10;
}

.bubbleSelf::before {
  content: '';
  position: absolute;
  top: 32px;
  left: -10px;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-right: 10px solid white;
}

.bubbleSelf::after {
  content: '';
  position: absolute;
  top: 32px;
  left: -11px;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-right: 10px solid #ddd;
  z-index: -1;
}
.close-btn {
  position: absolute;
  top: 8px;
  right: 10px;
  background: none;
  border: none;
  font-size: 18px;
  color: #95a5a6;
  cursor: pointer;
  transition: color 0.2s;
}
.close-btn:hover {
  color: #e74c3c;
}
</style>
